import React from 'react';
import { useSelector } from 'react-redux';
import { Grid, repeat } from '@adobe/react-spectrum';
import { ColorButton } from 'app/views/components/core/ColorButton';
export const ColorsGrid = (props) => {
    const { onSelect } = props;
    const colors = useSelector((state) => state.editor.colors);
    return (React.createElement(Grid, { columns: repeat(5, 'size-400'), rows: repeat(1, 'size-400'), justifyContent: "stretch", gap: "size-100" }, colors.map(swatchColor => (React.createElement(ColorButton, { key: swatchColor, color: swatchColor, onPress: onSelect })))));
};
